import { SsoInvitationGenericError } from '@hotjar/webapp/features/Activation/SsoError/SsoInvitationGenericError';
import { InviteRegisterForm, InvalidTokenScreen, EmailExistsScreen } from './components';
import type { InviteRegisterFormProps } from './components';
import { RegisterLayout } from '../components';

type RegistrationFromInviteProps = {
  isLoading: boolean;
  isSsoError: boolean;
  isInvalidToken: boolean;
  emailExists?: boolean;
} & InviteRegisterFormProps;

export const RegistrationFromInvite = ({
  isLoading,
  isSsoError,
  isInvalidToken,
  emailExists,
  ...props
}: RegistrationFromInviteProps): JSX.Element => {
  if (isSsoError) return <SsoInvitationGenericError />;

  let content = null;
  const verifiedIfEmailExists = typeof emailExists === 'boolean';

  if (isInvalidToken) {
    content = <InvalidTokenScreen />;
  } else if (emailExists) {
    content = <EmailExistsScreen />;
  } else {
    content = <InviteRegisterForm {...(props as InviteRegisterFormProps)} />;
  }

  return <RegisterLayout isLoading={isLoading || !verifiedIfEmailExists}>{content}</RegisterLayout>;
};
